import { AuthService } from 'src/app/services/auth.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class PermissionUserGuardGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService:AuthService,
    private toast: ToastrService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      let retour=this.authService.verifyPermission(route.data.perms);
      let user:any;
      console.log(retour);
      if(!retour) {
        this.toast.error('Accès non autorisé');
        this.router.navigateByUrl('/').then();
      }
      return retour
  }
  
}
